import type { IconName } from '~/shared/ui/Icon'

import type { PlaceholderName, PlaceholderSize } from './types'

/** Позы, которые нужны пустым состояниям. Полный набор поз живёт в `modules/lunya`. */
export type PlaceholderPose = 'BASE' | 'CALLING' | 'TENDER'

type PlaceholderIllustration =
  | { kind: 'MASCOT'; pose: PlaceholderPose }
  | { kind: 'ICON'; iconName: IconName }

/**
 * ЕДИНСТВЕННОЕ место маппинга «состояние → иллюстрация» (основатель, п.20).
 *
 * Отдельных артов под пустые состояния нет и не нужно: у маскота есть позы, и они говорят
 * ровно то, что нужно сказать. «Нет связей» — Луня зовёт, «ничего не прилетело» — сидит
 * тихо. Технические состояния (ERROR/OFFLINE) остаются нейтральной контурной иконкой
 * в кружке, без красного (правило «красный только в трёх местах»).
 */
export const PLACEHOLDER_ILLUSTRATION: Record<PlaceholderName, PlaceholderIllustration> = {
  EMPTY: { kind: 'MASCOT', pose: 'BASE' },
  NO_LINKS: { kind: 'MASCOT', pose: 'CALLING' },
  NO_HISTORY: { kind: 'MASCOT', pose: 'BASE' },
  NO_NOTIFICATIONS: { kind: 'MASCOT', pose: 'TENDER' },
  ERROR: { kind: 'ICON', iconName: 'info' },
  OFFLINE: { kind: 'ICON', iconName: 'refresh' },
}

/**
 * Позы маскота файлами, а не через `modules/lunya`: `shared/ui` не имеет права знать про
 * слои выше (правило 1). Мелкий размер берёт облегчённый исходник базовой позы, чтобы
 * в кружок 64px не грузился килобайтный арт.
 */
const MASCOT_POSE_SRC: Record<PlaceholderPose, string> = {
  BASE: '/images/lunya.png',
  CALLING: '/images/lunya-calling.png',
  TENDER: '/images/lunya-tender.png',
}

export const getPlaceholderMascotSrc = (pose: PlaceholderPose, size: PlaceholderSize): string =>
  pose === 'BASE' && size !== 'L' ? '/images/lunya-300.png' : MASCOT_POSE_SRC[pose]

export const PLACEHOLDER_SIZE_CONFIG: Record<
  PlaceholderSize,
  { illustration: number; icon: number }
> = {
  S: { illustration: 64, icon: 22 },
  M: { illustration: 104, icon: 28 },
  L: { illustration: 148, icon: 34 },
}
